import React from 'react';
import { type LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ActionButton {
  label: string;
  onClick: () => void;
}

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  /** Simple button action, OR pass a ReactNode for complex triggers (e.g. dialogs) */
  action?: ActionButton | React.ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className = '' }: EmptyStateProps) {
  const renderAction = () => {
    if (!action) return null;
    // If it's a ReactNode (not a plain action object), render it directly
    if (React.isValidElement(action) || typeof action !== 'object' || !('label' in action)) {
      return action as React.ReactNode;
    }
    const btnAction = action as ActionButton;
    return (
      <Button onClick={btnAction.onClick} size="sm" className="gap-1.5">
        {btnAction.label}
      </Button>
    );
  };

  return (
    <div className={`flex flex-col items-center justify-center py-12 text-center ${className}`}>
      <div className="w-14 h-14 rounded-xl bg-[var(--bg-secondary)] flex items-center justify-center mb-4 border border-[var(--border-color)]">
        <Icon size={28} className="text-[var(--text-secondary)]" />
      </div>
      <h3 className="text-lg font-semibold mb-1">{title}</h3>
      <p className="text-sm text-[var(--text-secondary)] mb-4 max-w-sm">{description}</p>
      {renderAction()}
    </div>
  );
}
